import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultLayoutComponent } from './_default_layout';
import { NotFoundComponent } from './_standart_pages/not-found/not-found.component';
import { MetaGuard } from '@ngx-meta/core';
import { GizlilikComponent } from './_standart_pages/gizlilik/gizlilik.component';
import { PrivacyPolicyComponent } from './_standart_pages/privacy-policy/privacy-policy.component';
import { KvkkComponent } from './_standart_pages/kvkk/kvkk.component';

const routes: Routes = [
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '404', component: NotFoundComponent },

  { path: '', component: DefaultLayoutComponent ,
    canActivateChild: [MetaGuard],
  children: [
    { path: '',
    loadChildren: () => import('./_standart_pages/home/home.module').then(mod => mod.HomeModule)},
    
      { path: 'program', 
     loadChildren: () => import('./pages/programlar/programlar.module').then(mod => mod.ProgramlarModule)},
    
    { path: 'canli-izle',
    loadChildren: () => import('./pages/canliyayin/canliyayin.module').then(mod => mod.CanliyayinModule)},

    { path: 'haftalik-yayin-programi',
    loadChildren: () => import('./pages/yayin-akisi/yayin-akisi.module').then(mod => mod.YayinAkisiModule)}, 

    { path: 'hakkinda',
    loadChildren: () => import('./pages/tv264/tv264.module').then(mod => mod.Tv264Module)}, 

    { path: 'iletisim',
    loadChildren: () => import('./pages/iletisim/iletisim.module').then(mod => mod.IletisimModule)},

    { path: 'kunye',
    loadChildren: () => import('./pages/kunye/kunye.module').then(mod => mod.KunyeModule)},

    { path: 'kurumsal',
    loadChildren: () => import('./pages/netpol/netpol.module').then(mod => mod.NetpolModule)},

    { path: 'arama-sonuclari',
    loadChildren: () => import('./_digi_modules/arama/arama.module').then(mod => mod.AramaModule)},

    { path: 'gizlilik-ilkesi', component: GizlilikComponent },
    { path: 'kvkk', component: KvkkComponent, data: {
      meta: {
        title: 'KVKK Aydınlatma Metni',
        override: true,
        description: 'TV264 6698 sayılı Kişisel Verilerin Korunması Kanunu aydınlatma metni'
      }
    }},
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
  ]
},
  { path: '**', component: NotFoundComponent },
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
